import { insertItem, removeItem } from "../utils/arrayUtils";
export function updateTrackHelper({
  currentPairwiseAlignmentIndex,
  pairwiseAlignments,
  upsertAlignmentRun,
  hasBeenTrimmed,
  alignmentId,
  alignmentTracks,
  alignmentTrackIndex,
  update
}) {
  const updateATs = (atsToUse, alignmentTrackIndex2) => {
    const removed = removeItem(atsToUse, alignmentTrackIndex2);
    return insertItem(
      removed,
      {
        ...atsToUse[alignmentTrackIndex2],
        alignmentData: {
          ...atsToUse[alignmentTrackIndex2].alignmentData,
          ...update
        },
        sequenceData: {
          ...atsToUse[alignmentTrackIndex2].sequenceData,
          ...update
        }
      },
      alignmentTrackIndex2
    );
  };
  upsertAlignmentRun({
    id: alignmentId,
    hasBeenTrimmed,
    ...pairwiseAlignments ? {
      pairwiseAlignments: pairwiseAlignments.map((ats, i) => {
        if (alignmentTrackIndex === 0) {
          return updateATs(ats, 0);
        }
        if (currentPairwiseAlignmentIndex !== void 0 ? currentPairwiseAlignmentIndex === i : alignmentTrackIndex - 1 === i) {
          return updateATs(ats, 1);
        }
        return ats;
      })
    } : {
      alignmentTracks: updateATs(
        alignmentTracks,
        Number(alignmentTrackIndex)
      )
    }
  });
}
